
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { SnackBarService } from '../../../../cw-utils/snackbar.service';
import { TableType } from '../../../models/backend-definitions.module';

@Injectable()
export class TableTypeEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    tableType: TableType;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getTableType()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getTableType(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('tableType/' + this.routeParams.id).subscribe((res: TableType ) => {
                    this.tableType = res;
                    this.onDataChanged.next(this.tableType);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(tableType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('tableType/', tableType).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(tableType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('tableType/', tableType).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(tableType): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('tableType/' + tableType.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
